module.exports = __webpack_public_path__ + "img/thumbnail_SandCat_f_normal.726797c0.png";